window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

/*
axios.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN': window.csrf_token
};*/
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrf_token;

// VUE and dependancies
import Vue from 'vue'
import store from './store'

// Others
import axios from 'axios'
import VueAxios from 'vue-axios'


import moment from 'moment'
import VueSweetalert2 from 'vue-sweetalert2';
import Buefy from 'buefy'

moment.locale('fr');
Vue.prototype.moment = moment

Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueSweetalert2);
Vue.use(Buefy, {
    defaultIconPack: 'fas',
});


const files = require.context('./components', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/*
* Initialisation VueJS + InitialiseStore
 */
import VueDatepickerUi from 'vue-datepicker-ui';
import 'vue-datepicker-ui/lib/vuedatepickerui.css';


Vue.component('Datepicker', VueDatepickerUi)

new Vue({
    store: store,
    beforeCreate() {
        this.$store.dispatch('initialiseStore');
    },
}).$mount('#pernet-app')
